/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    pre: "pre",
    code: "code",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Tagged Template Literals"
    }), "\n", _jsx(_components.p, {
      children: "Tagged Template Literals are a new feature in ES6. They let you define custom string interpolation rules,\nwhich is how we're able to create styled components."
    }), "\n", _jsx(_components.p, {
      children: "If you pass no interpolations, the first argument your function receives is an array with a string in it."
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "// These are equivalent:\nfn`some string here`;\nfn(['some string here']);\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "Once you pass interpolations, the array contains the passed string, split at the positions of the interpolations.\nThe rest of the arguments will be the interpolations, in order."
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "const aVar = 'good';\n\n// These are equivalent:\nfn`this is a ${aVar} day`;\nfn(['this is a ', ' day'], aVar);\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["This is a bit cumbersome to work with, but it means that we can receive variables, functions, or mixins\n(", _jsx(_components.code, {
        children: "css"
      }), " helper) in styled components and can flatten that into pure CSS."]
    }), "\n", _jsxs(_components.p, {
      children: ["Speaking of which, during flattening, styled-components ignores interpolations that evaluate to ", _jsx(_components.code, {
        children: "undefined"
      }), ", ", _jsx(_components.code, {
        children: "null"
      }), ",\n", _jsx(_components.code, {
        children: "false"
      }), ", or an empty string (", _jsx(_components.code, {
        children: "\"\""
      }), "), which means you're free to use\n", _jsx(_components.a, {
        href: "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Logical_AND#Short-circuit_evaluation",
        children: "short-circuit evaluation"
      }), "\nto conditionally add CSS rules."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "const Title = styled.h1<{ $upsideDown?: boolean; }>`\n  /* Text centering won't break if props.$upsideDown is falsy */\n  ${props => props.$upsideDown && 'transform: rotate(180deg);'}\n  text-align: center;\n`;\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["If you want to learn more about tagged template literals, check out Max Stoiber's article:\n", _jsx(_components.a, {
        href: "https://mxstbr.blog/2016/11/styled-components-magic-explained/",
        children: "The magic behind 💅🏾 styled-components"
      })]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
